<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="群成员列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
          </div>
            <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button
                color="info"
                small
                @click="showJoinGroup = true"
              >
                添加群组成员
              </va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="members"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listChannelMembers"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <va-avatar>
              <img :src="formatAvatar(props.rowData.avatar)">
            </va-avatar>
          </template>

          <template slot="nickname" slot-scope="props">
            <va-button color="dark" flat small :to='{path:`/admin/users/updateUser/${props.rowData.uid}`}'>
              {{ formatNickname(props.rowData.nickname) }}
            </va-button>
          </template>

          <template slot="actions" slot-scope="props">
            <va-popover message="删除群成员" placement="top">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-user-times"
                @click="deleteModal = true; kickoutGroupUid=props.rowData.uid"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="移除群成员"
          okText="提交"
          position="center"
          message="请确认是否要移除该成员？"
          @ok="confirmDelete"
        />
        <va-modal
          v-model="showJoinGroup"
          title="添加群成员"
          okText="提交"
          position="center"
          size="large"
          @ok="confirmJoinGroup"
        >
          <va-select
            v-model="joinGroupUid"
            label="请选择用户名"
            textBy="nickname"
            :options="libaUserNicknames"
            searchable
            width="350px"
          />
        </va-modal>
      </va-card>
    </div>
  </div>
</template>

<script>

import groupApi from '../../api/group'
import userApi from '../../api/user'

export default {
  data () {
    return {
      members: [],
      loading: true,
      groupId: null,
      kickoutGroupUid: null,
      libaUsers: [],
      libaUserNicknames: [],
      normalMode: true,
      deleteModal: false,
      showJoinGroup:false,
      libaUsers: [],
      libaUserNicknames: [],
      joinGroupUid: [],
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
        },
        {
          name: '__slot:nickname',
          title: '用户名',
          width: '30%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '加入时间',
          width: '30%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '30%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    const params = this.$route.params
    console.log(params)
    this.groupId = params.groupId
    this.listGroupMembers()
        //加载libaUser
    this.listLibaUser()
  },
  methods: {
    libaUserNickname () {
      const nicknames = []
      for (let i = 0; i < this.libaUsers.length; i++) {
        const item = {}
        item.id = this.libaUsers[i].uid
        item.nickname = this.libaUsers[i].nickname + ' (' + item.id + ')'
        nicknames.push(item)
      }
      console.log(nicknames)
      this.libaUserNicknames = nicknames
    },
    listLibaUser () {
      const params = {
        pageNumber: 1,
        pageSize: 10000,
      }
      userApi.listUser(params)
        .then(response => {
          this.libaUsers = response.users
          this.libaUserNickname()
        })
    },
    formatAvatar (avatar) {
      return avatar + '?x-oss-process=style/avatar'
    },
    formatNickname (nickname) {
      if (nickname == null) {
        return ''
      }
      if (nickname.length <= 10) {
        return nickname
      } else {
        return nickname.substr(0, 10) + '...'
      }
    },
    listGroupMembers() {
      this.loading = true
      groupApi.listGroupUserSimpleInfo(this.groupId)
        .then(response => {
          this.members = response.users
          this.loading = false
        })
    },
    confirmDelete () {
      // 移除用户出群组
      if (this.kickoutGroupUid == null) {
        return
      }
      const data = {
        uid: this.kickoutGroupUid,
        groupId: this.groupId,
      }
      groupApi.kickOutGroup(data).then(response => {
        if (response.success === true) {
          this.listGroupMembers()
        }
      }).catch(error => {
        alert(error.msg)
      })
    },
    confirmJoinGroup () {
      if (this.joinGroupUid == null) return
      const data = {
        uid: this.joinGroupUid.id,
        groupId: this.groupId,
      }
      groupApi.joinGroup(data)
        .then(response => {
          if (response.success === true) {
            this.listGroupMembers()
          }
        }).catch(error => {
          alert(error.msg)
        })
    },
  },
}

</script>
